/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyStockClosure from './pharmacy-stock-closure';
import PharmacyStockClosureDetail from './pharmacy-stock-closure-detail';

const PharmacyStockClosureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyStockClosure />} />
    <Route path=":id">
      <Route index element={<PharmacyStockClosureDetail />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyStockClosureRoutes;
